import React, { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, DELETE_CHIPPING_ORDER, GET_APPROVED_STAKEHOLDERS, GET_CHIPPING_ORDER_LIST } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from '@mui/x-data-grid';
import { Container, Button, Box, Card, IconButton, TextField, FormControl, Stack, Tooltip, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tabs, CardContent, Grid, Autocomplete } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES } from "../../../common/constants";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { AddIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

function ChippingOrders() {
    const { state } = useLocation();
    const location = useLocation();
    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [chippingOrderDetails, setChippingOrderDetails] = useState([]);
    const [lLElist, setLLElist] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState(location.state?.tabValue ?? 0);
    const [searchFilter, setSearchFilter] = useState({
        "chippingOrderFromDate": null,
        "chippingOrderToDate": null,
    });
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

    const role = getLocalStorageItem('role');

    const isRestrictedRole =
        role === PIT_ROLES.ProcessingIncharge ||
        role === PIT_ROLES.Incharge;

    useEffect(() => {
        getChippingOrdersList();
    }, [searchFilter, searchTerm, activeTab]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const onViewDetails = (cellValues) => {
        navigate('./chippingOperation', {
            state: { selectedRow: cellValues.row, pageName: 'chippingOrders', tabValue: activeTab }
        });
    }

    const onAddChippingOperation = () => {
        if (chippingOrderDetails?.every((item) => item.chippingStatus === "CompleteChippingDone")) {
            navigate('./chippingOperation');
        }
        else toast.error("Please complete the existing chipping order or delete before creating new one");
    }

    function onConfirmCallBack() {
        handleConfirmLogModalClose();
        deleteChippingOrder();
    }

    function onCancelBack() {
        handleConfirmLogModalClose();
    }

    const getChippingOrdersList = () => {
        let data = {
            "stakeholderUrn": decoded.extension_URN ?? searchTerm ?? '',
            "chippingOrderFromDate": searchFilter?.chippingOrderFromDate,
            "chippingOrderToDate": searchFilter?.chippingOrderToDate,
            "isSapGRNAdded": activeTab === 1
        }

        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_CHIPPING_ORDER_LIST, data, { headers })
            .then(res => {
                loaderService.hideLoader()
                res.data.chippingOrderList.sort((a, b) => {
                    if (a.chippingOrderNo < b.chippingOrderNo) {
                        return 1
                    } else {
                        return -1;
                    }
                })
                setChippingOrderDetails(res.data.chippingOrderList)
            })
            .catch(function (err) {
                loaderService.hideLoader()
                console.log(err);
                toast.error(err.message);

            });
    };

    const deleteChippingOrder = () => {
        loaderService.showLoader()
        apiClient
            .post(
                DELETE_CHIPPING_ORDER,
                {
                    "chippingOrderNo": deleteChippingOrderNo
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                getChippingOrdersList();
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    };

    const handleDateChange = (name, value) => {
        const formatted = value ? value.format("YYYY-MM-DD") : null;

        setSearchFilter((prev) => {
            if (
                name === "chippingOrderToDate" &&
                prev.chippingOrderFromDate &&
                dayjs(prev.chippingOrderFromDate).isAfter(value)
            ) {
                return {
                    ...prev,
                    chippingOrderToDate: formatted,
                    chippingOrderFromDate: formatted
                };
            }

            return {
                ...prev,
                [name]: formatted
            };
        });
    };

    function searchAsnDetails(e) {
        getChippingOrdersList();
    }

    const [deleteChippingOrderNo, setDeleteChippingOrderNo] = useState("")

    const onDeleteChippingorder = (orderNo) => {
        setDeleteChippingOrderNo(orderNo);
        handleConfirmLogModalOpen();
    }


    const columns = [
        { field: 'chippingOrderNo', headerName: 'Chipping Order No.', width: 190 },
        {
            field: 'chippingOrderDate', headerName: 'Chipping Order Date', width: 190,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'chippingQuantity', headerName: 'Chipping Order Quantity (MT)', width: 180 },
        { field: 'rbQuantity', headerName: 'Consumed Raw bamboo Quantity (MT)', width: 200 },
        { field: 'preChippingQuantity', headerName: 'Pre-chiping Quantity (MT)', width: 160 },
        { field: 'postChippingQuantity', headerName: 'Post-chipping Quantity (MT)', width: 160 },
        { field: 'balanceQuantity', headerName: 'Heap Balance Quantity (MT)', width: 170 },
        { field: 'chippingStatus', headerName: 'Status', width: 200 },
        { field: 'sapGrnNumberRawBamboo', headerName: 'SAP GRN No.', width: 180, hide: activeTab !== 1 },
        {
            field: 'Action', width: 200,
            renderCell: (cellValues) => {
                return (
                    <>
                        <Tooltip title="View">
                            <IconButton
                                color="primary"
                                onClick={() => onViewDetails(cellValues)}>
                                <ViewIcon />
                            </IconButton>
                        </Tooltip>
                        {cellValues?.row?.chippingStatus == "InProgress" && <Tooltip title="Delete"><IconButton
                            disabled={isRestrictedRole}
                            color="error"
                            onClick={() => onDeleteChippingorder(cellValues?.row?.chippingOrderNo)}>
                            <DeleteIcon />
                        </IconButton></Tooltip>}
                    </>
                );
            }
        },
    ];

    useEffect(() => {
        getLLElist();
    }, []);

    const getLLElist = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": "LLE"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setLLElist(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT10</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Chipping Orders
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <Stack direction="row" spacing={1}>
                            <Button disabled={isRestrictedRole} hidden={activeTab === 1} startIcon={<AddIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onAddChippingOperation(e)} >
                                Create Chipping Order
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                <Card>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, pt: 1 }}>
                        <Tabs value={activeTab} onChange={handleTabChange}>
                            <Tab label="Chipping Orders" />
                            <Tab label="Sent to SAP" />
                        </Tabs>
                    </Box>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={4}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Chipping Order From Date"
                                            value={searchFilter?.chippingOrderFromDate ? dayjs(searchFilter.chippingOrderFromDate) : null}
                                            inputFormat="DD/MM/YYYY"
                                            maxDate={searchFilter?.chippingOrderToDate}
                                            onChange={(value) => handleDateChange("chippingOrderFromDate", value)}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Chipping Order To Date"
                                            value={searchFilter?.chippingOrderToDate ? dayjs(searchFilter.chippingOrderToDate) : null}
                                            inputFormat="DD/MM/YYYY"
                                            onChange={(value) => handleDateChange("chippingOrderToDate", value)}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={4} hidden={decoded.extension_URN}>
                                <Autocomplete
                                    value={lLElist.find((o) => o.urn === searchTerm) || null}
                                    getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
                                    isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                    onChange={(_, newValue) => {
                                        const urn = newValue?.urn ?? "";
                                        setSearchTerm(urn);
                                    }}
                                    options={lLElist || []}
                                    renderInput={(params) => <TextField {...params} label="Search URN" variant="outlined" fullWidth />}
                                />
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {
                                        chippingOrderDetails &&
                                        <DataGrid rows={chippingOrderDetails}
                                            columns={columns}
                                            disableSelectionOnClick
                                            pageSize={10}
                                            getRowId={(row) => row.chippingOrderNo}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Delete" />

        </>
    );
}
export default ChippingOrders;
